import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'

function Tabs({ tabs, activeTab, setActiveTab }) {
  return (
    <>
      <ButtonGroup
        className="mb-2 shadow-sm rounded-start rounded-end"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {tabs.map((tab) => (
          <Button
            key={tab.value}
            variant={'light'}
            onClick={() => setActiveTab(tab.value)}
            className={`py-1.5 px-3 ${
              activeTab === tab.value ? 'tabs-active' : 'bg-white'
            }`}
          >
            {tab.name}
          </Button>
        ))}
      </ButtonGroup>
    </>
  )
}

export default Tabs
